import L from 'leaflet'
import "leaflet.markercluster";

'use strict';

class VillageMap {
  constructor(elem) {
    this.elem = elem;
    this.villageItem = document.querySelector('.village-item');
    // this.location = [];
    this.location = { lat: -50.82, lng: 155.24 }; // Default location
    this.mapInitialized = false;
    this.events();
  }

  events() {
    this.initData();
    this.initMap();
  }

  initData() {
      // this.location = JSON.parse(this.villageItem.dataset.location);
      if (this.villageItem) {
        this.location = JSON.parse(this.villageItem.dataset.location);
      }
  }

  initMap() {
    this.mapInitialized = true;

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ',
      maxZoom: 20
    });

    const latlng = L.latLng(-50.82, 155.24);
    this.map = L.map('village-map', { center: latlng, zoom: 12, layers: [tiles] });

    const customIcon = L.icon({
      iconUrl: '/themes/siblu/dist/assets/svg/marker.svg',
      shadowUrl: null,
      iconSize: [20, 30],
      shadowSize: [50, 64],
      iconAnchor: [-0, 0],
      shadowAnchor: [0, 0],
      popupAnchor: [7, -0]
    });

    let marker = L.marker(L.latLng(this.location.lat, this.location.lng), { icon: customIcon });

    marker.addTo(this.map);

    this.map.setView(marker.getLatLng(), 12);
  }
}

const villageMapEl = document.querySelector('.js-village-map');
if (villageMapEl) {
  villageMapEl.SearchResultMap = new VillageMap(villageMapEl);
}
